import { Activity } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { CarlaHealthPage } from './pages/CarlaHealthPage'

/**
 * CARLA Health — Phase 4 of the 2026-10 chat rebuild. Admin-only view of
 * per-tool usage / failure / latency (human chat only), answers with
 * linter flags, 👍/👎 feedback, and the flagged-answer queue that feeds
 * the eval set. Observational; no actions.
 */
export default defineModule({
  id: 'carla-health',
  name: 'CARLA Health',
  shortName: 'CARLA Health',
  icon: Activity,
  navSection: 'admin',
  navOrder: 25,
  urlNamespace: '/carla-health',
  routes: [{ path: '/', element: CarlaHealthPage, label: 'CARLA Health' }],
  permissions: ['admin'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',
  keyboardShortcut: 'g c h',
  commandPaletteEntries: [
    {
      label: 'Go to CARLA Health',
      keywords: ['carla', 'health', 'tools', 'feedback', 'lint', 'eval'],
      path: '/',
      group: 'modules',
      shortcut: 'g c h',
    },
  ],
})
